const isRequiredOptions = [
    {text: '필수', value: true},
    {text: '선택', value: false},
];
const valueTypeOptions = [
    {text: '정수', value: 'int'},
    {text: '문자열', value: 'str'},
    {text: '선택 목록', value: 'list'},
];

// DS 표 규칙: No. → 메인(키 이름 = 상세 창) → 데이터 → 행 아이콘(복사 · 삭제 · 상세)은 맨 끝.
// 폭을 안 적은 키 이름 · 프로젝트가 남는 폭을 나눠 갖는다(표 최소 폭은 ManageSchemaInput.vue)
const columns = [
    {key: 'index', label: 'No.', thClass: ['ds-cell-no'], tdClass: ['ds-cell-no'], thStyle: {width: '64px'}},
    {key: 'key_name', label: '키 이름'},
    {key: 'project_id', label: '프로젝트'},
    {key: 'value_type', label: '타입', thStyle: {width: '110px'}},
    {key: 'is_required', label: '필수', thStyle: {width: '88px'}},
    {key: 'sort_order', label: '순서', thClass: ['text-right'], tdClass: ['ds-cell-num'], thStyle: {width: '72px'}},
    {key: 'updated_at', label: '수정일시', tdClass: ['ds-cell-nowrap'], thStyle: {width: '168px'}},
    // 28 아이콘 3개 + 사이 4 + 좌우 16
    {key: 'detail', label: '동작', tdClass: ['text-right'], thStyle: {width: '124px'}},
];


const allowValuesColumn = [
    {
        key: 'sort_order',
        label: '순서',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0', 'text-center'],
        tdClass: ['text-center'],
    },
    {
        key: 'actual_value',
        label: '실제 값',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0', 'th-left'],
        tdClass: ['td-left', 'text-truncate']
    },
    {
        key: 'label_key',
        label: '라벨 키',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0', 'th-left'],
        tdClass: ['td-left', 'text-truncate']
    },
    {
        key: 'label_texts_ko',
        label: '한국어',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0', 'th-left'],
        tdClass: ['td-left', 'text-truncate']
    },
    {
        key: 'label_texts_en',
        label: '영어',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0', 'th-left'],
        tdClass: ['td-left', 'text-truncate']
    },
    {
        key: 'label_texts_ca',
        label: '중국어',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0', 'th-left'],
        tdClass: ['td-left', 'text-truncate']
    },
];



export {columns,isRequiredOptions,valueTypeOptions, allowValuesColumn};
